import React from 'react';
import {View, Text, TextInput} from 'react-native';
import styles from '../../style/costCalculator';

/**
 * Plain text/email/multiline input for the "Tell your team" panel — separate from
 * NumberField because those fields aren't numeric and don't need `keyboardType="numeric"`.
 */
const TextField = ({label, value, onChangeText, testID, multiline, keyboardType}) => {
  return (
    <View style={styles.field}>
      {label ? <Text style={styles.fieldLabel}>{label}</Text> : null}
      <TextInput
        testID={testID}
        style={multiline ? styles.textArea : styles.input}
        value={value || ''}
        onChangeText={onChangeText}
        multiline={!!multiline}
        keyboardType={keyboardType || 'default'}
        autoCapitalize="none"
      />
    </View>
  );
};

export default TextField;
